import { useEffect, useState } from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

function Header() {
    const dispatch = useDispatch();
    // eslint-disable-next-line
    const [comcode, setComcode] = useState("");
    // eslint-disable-next-line
    const [userid, setUserid] = useState("");
    // eslint-disable-next-line
    const [usertype, setUsertype] = useState("");
    // eslint-disable-next-line
    const [username, setUsername] = useState("");
    // eslint-disable-next-line
    const [userToken, setUserToken] = useState("");

    const fnLogout = () => {
        dispatch({ type: "authUpdate", payload: null });
        localStorage.removeItem("userinfo");

        window.location.href = "/";
    };

    useEffect(() => {
        let userinfo = localStorage.getItem("userinfo");
        if (userinfo) {
            userinfo = JSON.parse(userinfo);
            setComcode(userinfo.comcode);
            setUserid(userinfo.userid);
            setUsertype(userinfo.usertype);
            setUsername(userinfo.username);
            setUserToken(userinfo.usertoken);
        }
    }, [comcode, userid, usertype, username, userToken]);

    return (
        <header>
            <div className="header-top-bar">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-sm-12 header-site-info">
                            <ul className="top-bar-info list-inline-item pl-0 mb-0">
                                <li className="list-inline-item">
                                    <i className="icofont-location-pin mr-2"></i>강원특별자치도
                                    춘천시 동면 만천로 57
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-6 col-sm-12">
                            {comcode && userid ? (
                                usertype === "0" ? (
                                    <div className="text-lg-right top-right-bar mt-2 mt-lg-0">
                                        <Link to="/MemberInfo">
                                            <span className="mr-3">{`${userid} (${username})`}</span>
                                        </Link>
                                        <Link to="/Admin/MemberList">
                                            <span className="mr-3">관리메뉴</span>
                                        </Link>
                                        <Link to="#" onClick={fnLogout}>
                                            <span>로그아웃</span>
                                        </Link>
                                    </div>
                                ) : (
                                    <div className="text-lg-right top-right-bar mt-2 mt-lg-0">
                                        <Link to="/MemberInfo">
                                            <span className="mr-3">{`${userid} (${username})`}</span>
                                        </Link>
                                        <Link to="#" onClick={fnLogout}>
                                            <span>로그아웃</span>
                                        </Link>
                                    </div>
                                )
                            ) : (
                                <div className="text-lg-right top-right-bar mt-2 mt-lg-0">
                                    <Link to="/Login">
                                        <span className="mr-3">로그인</span>
                                    </Link>
                                    <Link to="/JoinStep01">
                                        <span>가입</span>
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <Navbar
                bg="light"
                expand="lg"
                className="navbar-expand-lg navigation"
                id="navbar"
            >
                <Container>
                    <Navbar.Brand as={Link} to="/">
                        <img src="/images/logo.png" alt="" className="img-fluid img-logo" />
                    </Navbar.Brand>

                    <Navbar.Toggle
                        className="collapsed"
                        data-toggle="collapse"
                        data-target="#navbarmain"
                        aria-controls="navbarmain"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="icofont-navigation-menu"></span>
                    </Navbar.Toggle>

                    <Navbar.Collapse className="navbar-collapse" id="navbarmain">
                        <Nav className="navbar-nav ml-auto">
                            <NavDropdown
                                title={
                                    <span>
                                        조합소개 <i className="icofont-thin-down"></i>
                                    </span>
                                }
                                id="menu01"
                            >
                                <NavDropdown.Item as={Link} to="/Greetings">
                                    이사장 인사말
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/History">
                                    연혁
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/Articles">
                                    조합정관 및 사업자윤리강령
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/Directions">
                                    찾아오시는 길
                                </NavDropdown.Item>
                            </NavDropdown>

                            <Link
                                className="menu-1st"
                                id="menu02"
                                to={`ABoardList?kind=docu`}
                            >
                                문서함
                            </Link>

                            <NavDropdown
                                title={
                                    <span>
                                        자료실 <i className="icofont-thin-down"></i>
                                    </span>
                                }
                                id="menu03"
                            >
                                <NavDropdown.Item
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=pds02")
                                    }
                                >
                                    정비업무 자료실
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=pds06")
                                    }
                                >
                                    검사업무 자료실
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=pds01")
                                    }
                                >
                                    산업안전보건 자료실
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=pds05")
                                    }
                                >
                                    조합임원 자료실
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=pds04")
                                    }
                                >
                                    서식 자료실
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=pds03")
                                    }
                                >
                                    기타 자료실
                                </NavDropdown.Item>
                                {usertype === "0" || usertype === "1" ? (
                                    <NavDropdown.Item
                                        onClick={() =>
                                            (window.location.href = "/ABoardList?kind=pds08")
                                        }
                                    >
                                        조합 자료실
                                    </NavDropdown.Item>
                                ) : null}
                            </NavDropdown>
                            <NavDropdown
                                title={
                                    <span>
                                        정보광장 <i className="icofont-thin-down"></i>
                                    </span>
                                }
                                id="menu04"
                            >
                                <NavDropdown.Item
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=pds07")
                                    }
                                >
                                    교육일정 및 신청안내
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=free")
                                    }
                                >
                                    자유게시판
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=schedule")
                                    }
                                >
                                    이사장 동정
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=gallery")
                                    }
                                >
                                    포토갤러리
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=joboffer")
                                    }
                                >
                                    구인정보
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=jobsearch")
                                    }
                                >
                                    구직정보
                                </NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    </Navbar.Collapse>

                    <Link className="menu-1st" id="menu05" to={`ABoardList?kind=laws`}>
                        자동차관련법규
                    </Link>
                </Container>
            </Navbar>
        </header>
    );
}

export default Header;
